exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("assets/images/send_to_device/bg.jpg"));

// Module
exports.push([module.id, "._2LWYdbGn4rpxAwdpHaztmP{background:linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.2)),url(" + ___CSS_LOADER_URL___0___ + ") center/cover;height:calc(100vh - 60px);display:flex;align-items:center;justify-content:center}._2LWYdbGn4rpxAwdpHaztmP p{margin-bottom:15px !important}._12chm1qDG62Q0CTrkcMgGZ{width:80vw;min-height:550px;max-width:700px}._2hz9Gv_EsbfyNE5DIXI1AJ{position:relative}._3jyd2GFPqmjixVia85ZImc{display:flex;justify-content:space-between}._3jyd2GFPqmjixVia85ZImc ._35TuBtSIp9KXhXAC6VC53C{font-size:14px;font-style:italic;margin-bottom:15px}._3jyd2GFPqmjixVia85ZImc .L_4e1NXlULWZfAo_V_G4C{margin-right:20px}\n", ""]);

// Exports
exports.locals = {
	"S2DLayout": "_2LWYdbGn4rpxAwdpHaztmP",
	"Modal": "_12chm1qDG62Q0CTrkcMgGZ",
	"modalContent": "_2hz9Gv_EsbfyNE5DIXI1AJ",
	"Footer": "_3jyd2GFPqmjixVia85ZImc",
	"stepText": "_35TuBtSIp9KXhXAC6VC53C",
	"prev": "L_4e1NXlULWZfAo_V_G4C"
};